export default __webpack_public_path__ + "static/media/review_paid_up_capital.ff350b74.svg";